export default __webpack_public_path__ + "static/media/icon-sync.be212a78.svg";